export class AplusLastCallStatusDTO {
    
    riskId?: string | undefined;
    isLastAPlusCallSuccess?: boolean | undefined;
    public constructor(init?: Partial<AplusLastCallStatusDTO>) {
      Object.assign(this, init);
    }
}